"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PhotoCamera = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M6,7 L7,7 L7.4472136,6.10557281 C7.78599762,5.42800475 8.47852386,5 9.23606798,5 L14.763932,5 C15.5214761,5 16.2140024,5.42800475 16.5527864,6.10557281 L17,7 L18,7 C19.1045695,7 20,7.8954305 20,9 L20,16 C20,17.1045695 19.1045695,18 18,18 L6,18 C4.8954305,18 4,17.1045695 4,16 L4,9 C4,7.8954305 4.8954305,7 6,7 Z M5,9 L5,16 C5,16.5522847 5.44771525,17 6,17 L18,17 C18.5522847,17 19,16.5522847 19,16 L19,9 C19,8.44771525 18.5522847,8 18,8 L17,8 C16.6212279,8 16.2749648,7.78599762 16.1055728,7.4472136 L15.6583592,6.5527864 C15.4889672,6.21400238 15.1427041,6 14.763932,6 L9.23606798,6 C8.85729592,6 8.5110328,6.21400238 8.34164079,6.5527864 L7.89442719,7.4472136 C7.72503518,7.78599762 7.37877206,8 7,8 L6,8 C5.44771525,8 5,8.44771525 5,9 Z M12,16 C9.790861,16 8,14.209139 8,12 C8,9.790861 9.790861,8 12,8 C14.209139,8 16,9.790861 16,12 C16,14.209139 14.209139,16 12,16 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z" })));
};
PhotoCamera.displayName = 'PhotoCamera';
exports.default = PhotoCamera;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PhotoCamera.js.map